import VdAcl from '@/directives/acl';

export default {
  install(Vue) {
    Vue.directive('acl', VdAcl);
  },
};
